// extracted by mini-css-extract-plugin
export var drawerBody = "f3o6J";
export var drawerContainer = "_sc79";
export var drawerHeader = "VTncA";
export var fullBleed = "Gbygh";
export var hiddenContent = "sL7LF";